import { FC } from 'react';

import { OButton, OPopper } from '@src/shared';

import useMediaRequestCta from './useMediaRequestCta';

import { CgClose } from 'react-icons/cg';

import { TMediaRequest } from '@src/types';

import './mediaRequestCta.scss';

interface Props {
  hostName: string;
  message: string;
  buttonLabel: string;
  anchorRef: React.RefObject<HTMLElement>;
  onConfirm: () => void;
  onClose: () => void;
  open: boolean;
  roleLabel?: string;
  request: TMediaRequest;
}

const MediaRequestCta: FC<Props> = ({
  hostName,
  message,
  buttonLabel,
  anchorRef,
  onConfirm,
  onClose,
  open,
  roleLabel,
  request,
}) => {
  const { handleOnClose, handleOnConfirm, processedMediaRequest } = useMediaRequestCta({
    onClose,
    onConfirm,
    open,
    request,
  });

  return (
    <OPopper
      isOpen={open && processedMediaRequest?.id === request?.id}
      position="top"
      anchorEl={anchorRef.current}
      customStyles={{
        root: { zIndex: 1400, padding: 0, minWidth: 'fit-content', border: 'unset', marginBottom: '15px !important' },
        boxRoot: { background: 'var(--tertiary-800)' },
      }}
      icon={null}
      withArrow
      isDismissible={false}
      disableClose={true}
      offset={[0, 16]}
    >
      <div className="request-cta-container">
        <div className="request-content">
          <p className="request-message">
            <span className="request-host-name">{hostName}</span> ({`the ${roleLabel}`}) {message}
          </p>
          <div className="actions">
            <OButton text={buttonLabel} variant="secondary" onClick={handleOnConfirm} />

            <button className="close-icon-circle icon-container" onClick={handleOnClose}>
              <CgClose size={20} className={'close-btn'} />
            </button>
          </div>
        </div>
      </div>
    </OPopper>
  );
};

export default MediaRequestCta;
